import { Injectable, signal } from '@angular/core';
import { TenantConfig } from '@app/core/interfaces/tenant-config.interface';

@Injectable({ providedIn: 'root' })
export class TenantState {
  private readonly _currentTenant = signal<TenantConfig | null>(null);

  readonly currentTenant = this._currentTenant.asReadonly();

  setCurrentTenant(tenant: TenantConfig): void {
    this._currentTenant.set(tenant);
  }

  clearTenant(): void {
    this._currentTenant.set(null);
  }
}
